// Module
var code = "<div class=\"search-filter\"> <search-filter-loadable dependency=\"!$ctrl.isLoading\"> <div class=\"search-filter-options\" ng-transclude></div> </search-filter-loadable> </div> ";
// Exports
module.exports = code;